import { isNil } from "@s-libs/micro-dash";
import { StudentActivityMetricsEntityItem } from "@/reports/types";

export interface TableData {
  student: {
    name: string;
    unique_id: string;
  };
  textLevel: {
    lexileLevel: string;
    gradeLevel: number;
  };
  views: number;
  activeTime: number | null | undefined;
  quizzes: number;
  quizScores: number | undefined;
  writePromptScore: number | undefined;
  annotations: number;
  viewDate?: Date;
  powerWordsScore: number | undefined;
}

const formatReadingActivityClassroomData = (
  responseData: StudentActivityMetricsEntityItem[],
): TableData[] => {
  if (isNil(responseData)) return [];

  const formattedData = responseData.map((dataEntity) => {
    const powerWordsFormattedScore = dataEntity.activities
      .powerwords_quiz_score_average
      ? Math.round(dataEntity.activities.powerwords_quiz_score_average * 100)
      : undefined;
    return {
      student: {
        name: `${dataEntity.last_name}, ${dataEntity.first_name}`,
        unique_id: dataEntity.student_unique_id,
      },
      textLevel: {
        lexileLevel: dataEntity.activities.article_lexile_level_viewed_average,
        gradeLevel: dataEntity.activities.article_grade_level_viewed_average,
      },
      views: dataEntity.activities.articles_viewed_count,
      activeTime: dataEntity.activities.article_time_average,
      quizzes: dataEntity.activities.quizzes_completed_count,
      quizScores: dataEntity.activities.quizzes_completed_score_average,
      writePromptScore: dataEntity.activities.write_prompts_score_average,
      annotations: dataEntity.activities.annotations_avg_count_by_article,
      powerWordsScore: powerWordsFormattedScore,
    };
  });

  return formattedData;
};

export default formatReadingActivityClassroomData;
